import { normalizeArray } from 'lib/graphql/normalize'

// TODO: Convert to TypeScript and fix GatsbyTypes errors
export const getCrematoria = (
  crematoriumListFromContentful,
  allCrematoriaFromBackstage
) => {
  const crematoria = crematoriumListFromContentful?.map((singleCrematorium) => {
    const matchingCrematorium = normalizeArray(allCrematoriaFromBackstage).find(
      (crematorium) => crematorium.externalId === singleCrematorium.externalId
    )
    if (matchingCrematorium) {
      return { ...matchingCrematorium, ...singleCrematorium }
    }
    return singleCrematorium
  })
  return crematoria
}
